export default {
  userGroupManagement: {
    Name: 'User Group Name',
    Status: 'Status',
    create: 'Create Group Name',
    edit: 'Edit Group Name',
    creator: 'Creator',
    userGroup: 'User Group',
    userGroupList: 'User Group',
    accountList: 'Account List',
    country: 'Country'
  }
};
